
export const showInfo = infoMessage => {
  window.notify.open({ type: 'info', message: infoMessage.text} );
}

export const showWarning = warningMessage => {
  window.notify.open({ type: 'warning', message: warningMessage });
}

export const showError = (...args) => {
  if(args.length > 1) {
    window.notify.open({ type: 'error', message: `<h1>${args[0]}</h1><p>${args[1]}</p>` });
  } else {
    window.notify.open({ type: 'error', message: `<p>${args[0]}</p>` });
  }
}

export const showProblem = response => {
  const detail = response.data?.detail ?  `<p>${response.data?.detail}</p>` : '';
  const message = `<h1>${response.data?.title}</h1>${detail}`;

  window.notify.open({ type: 'error', message });
}

export default {
  showInfo,
  showWarning,
  showError,
  showProblem
}
